import json from "../json/jmisRoutingPolicy.json";

export default async () => JSON.parse(JSON.stringify(await json));
